import { useTranslation } from 'react-i18next'

import EditWidgetForm from './EditWidgetForm'
import Widget from '../Widget'

export const usePLACES_COUNTER_CONFIG = () => {
  const { t } = useTranslation('common')

  return {
    id: 'PLACES_COUNTER',
    name: t('widgets.placesCounter.name'),
    description: t('widgets.placesCounter.description'),
    color: 'dark2',
    icon: 'RiTimerLine',
    categories: [t('widgets.placesCounter.category')],
    previewWidth: '45%',

    initialState: {
      name: t('widgets.placesCounter.initialStateName'),
      size: { width: 25, height: 175 },
      data: {}
    },

    Presentation: Widget,
    Form: EditWidgetForm
  }
}
